import { getFromCache, saveToCache } from "../utils/cache";
import {
  deleteCall,
  getCall,
  postCall,
  postFileCall,
  getFileCall,
  putCall,
} from "../utils/calls";
import {
  dispatchErrorMessage,
  loadingToast,
  showErrorToast,
  showInfoToast,
  updateToast,
} from "../utils/toast";
import { formatDate } from "../utils/utils";

export const getChatsInfo = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/chats/" + bot_id);
  if (res[0]) {
    return res[0];
  } else return null;
};

let controller = new AbortController();
export const getChatbyId = async (chat) => {
  controller.abort();
  controller = new AbortController();
  const bot_id = localStorage.getItem("bot");
  const res = await getCall(
    "/chats/view/" + bot_id + "/" + chat?.id,
    controller.signal
  );
  if (res[0]) {
    console.log("res[0]", res[0]);
    return res[0];
  } else {
    if (res[1]) {
      return null;
    } else return "canceled";
  }
};

export const changeChatCategory = async (chat, state) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/requests/state/" + bot_id, {
    id: chat.id,
    state: state,
  });
  if (res[0]) {
    updateToast(
      idt,
      "success",
      "El chat ha sido cambiado de casilla correctamente."
    );
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al mover");
    return null;
  }
};

export const addCommentChat = async (chat, message) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/requests/message/" + bot_id, {
    id: chat.id,
    message: message,
  });
  if (res[0]) {
    updateToast(idt, "success", "Comentario agregado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al agregar comentario.");
    return null;
  }
};

export const shareChat = async (chat, data) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/share/" + bot_id, {
    chat_id: chat.id,
    contact_id: data.contact_id,
    comment: data.comment,
    summary: data.summary
  });
  if (res[0]) {
    updateToast(idt, "success", "Conversacion compartida correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al compartir conversacion.");
    return null;
  }
};

export const changeArea = async (selected_area_id, chat) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/requests/change/" + bot_id, {
    selected_area_id: selected_area_id,
    id: chat.id,
  });
  if (res[0]) {
    updateToast(idt, "success", "Cambiado de área exitosamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al cambiar de área");
    return null;
  }
};

export const changeUser = async (chat, user_id) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/requests/assign/" + bot_id, {
    id: chat.id,
    user_id: user_id === "none" ? null : user_id,
  });
  if (res[0]) {
    updateToast(idt, "success", "Usuario asginado exitosamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al asignar usuario.");
    return null;
  }
};

export const reassignLiveChat = async (chat, area_id, user_id) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/requests/reassign/" + bot_id, {
    id: chat.id,
    area_id,
    user_id,
  });
  if (res[0]) {
    updateToast(idt, "success", "Usuario asignado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al reasignar chat.");
    return null;
  }
};

export const getDefaultFilters = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/chats/filter/settings/" + bot_id);
  if (res[0]) {
    return res[0].filter_settings;
  } else return null;
};

  export const getAdsList = async () => {
    const bot_id = localStorage.getItem("bot");
    const res = await getCall("/chats/ads/" + bot_id);
    if (res[0]) {
      return res[0].ads;
    } else return null;
  };

  export const getCampaignsList = async () => {
    const bot_id = localStorage.getItem("bot");
    const res = await getCall("/chats/campaigns/" + bot_id);
    if (res[0]) {
      return res[0].campaigns;
    } else return null;
  };

const normalizeSummaryCharactersLimit = (value) => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }

  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
    return null;
  }

  return Math.trunc(parsedValue);
};

export const getChatSummary = async (selectedChat, options = {}) => {
  const bot_id = localStorage.getItem("bot");
  const hasPromptOverride = Object.prototype.hasOwnProperty.call(
    options,
    "prompt"
  );
  const summarySettings = hasPromptOverride ? null : await getChatSummaryConfig();
  const payload = {
    prompt: hasPromptOverride ? options.prompt ?? "" : summarySettings?.prompt ?? "",
    characters_limit: normalizeSummaryCharactersLimit(
      options.charactersLimit ?? options.characters_limit
    ),
  };
  const res = await postCall(
    "/chats/summary/" + bot_id + "/" + selectedChat.id,
    payload
  );
  if (res[0]) {
    return { summary: res[0].summary_conversation, errorMessage: null };
  } else {
    let errorMessage = "Error al obtener el resumen del chat.";
    if (res?.[1] && res[1].data) {
      if (res[1].data.data?.message) {
        errorMessage = res[1].data.data.message;
      } else if (res[1].data.message) {
        errorMessage = res[1].data.message;
      }
    }
    return { summary: null, errorMessage };
  };
};

export const getChatSummaryConfig = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/chats/summary/settings/" + bot_id);
  if (res[0]) {
    const summarySettings = res[0].summary_settings || {};
    return {
      enabled: summarySettings.enabled,
      prompt: summarySettings.prompt || "",
      charactersLimit: summarySettings.characters_limit ?? null,
    };
  } else return null;
};

export const saveChatSummaryConfig = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const payload = {
    enabled: data.enabled,
    prompt: data.prompt || "",
  };
  const res = await postCall("/chats/summary/settings/" + bot_id, payload);
  if (res[0]) {
    const summarySettings = res[0].summary_settings || {};
    updateToast(idt, "success", "Configuración guardada correctamente.");
    return {
      enabled: summarySettings.enabled,
      prompt: summarySettings.prompt || "",
    };
  } else {
    dispatchErrorMessage(idt, res, "Error al guardar configuración.");
    return null;
  }
};

export const setDefaultArea = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/chats/default/area/" + bot_id, null);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const setDefaultFilters = async (data) => {
  const formattedData = {
    category: data?.category,
    state: data?.state,
    channel: data?.channel,
    origin: data?.origin,
    labels: data?.labels,
    sender_id: data?.chatId,
    type: data?.type,
    status: data?.status,
    active: data?.active,
    username: data?.username,
    keyword: data?.keyword,
    area_name: data?.area_name,
  };
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/filter/settings/" + bot_id, formattedData);
  if (res[0]) {
    updateToast(idt, "success", "Filtros por defecto guardados correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al guardar filtros.");
    return null;
  }
};

export const getFilterChats = async ({
  endDate = "",
  initDate = "",
  type = "",
  category = "",
  channel = "",
  chatId = "",
  username = "",
  keyword = "",
  area_name = "",
  lead_score = "",
  origin = "all",
  origin_data = null,
  state = "",
  status = "",
  active = "",
  labels = [],
  page = 1,
}) => {
  const bot_id = localStorage.getItem("bot");
  const data = {
    type: type,
    date_end: endDate ? formatDate(endDate) : "",
    date_start: initDate ? formatDate(initDate) : "",
    category: category,
    channel: channel,
    sender_id: chatId,
    keyword: keyword,
    username: username,
    active: active,
    state: state,
    status: status,
    labels: labels,
    area_name: area_name,
    lead_score: lead_score,
    origin: origin,
    origin_data:
      origin === "ad" || origin === "campaign" ? origin_data : null,
    page_number: page,
    intent: "",
  };
  const res = await postCall("/chats/filter/" + bot_id, data);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const sendMessage = async (chat, message, targetedMessageId, generated) => {
  const bot_id = localStorage.getItem("bot");
  const res = await postCall("/chats/requests/send/" + bot_id, {
    target_id: targetedMessageId,
    message: message,
    generated: generated,
    id: chat.id,
  });
  if (res[0]) {
    return res[0];
  } else {
    showErrorToast(res, "Error al enviar el mensaje.");
    return null;
  }
};

export const sendContact = async (chat, contact_id, targetedMessageId) => {
  const bot_id = localStorage.getItem("bot");
  const res = await postCall("/chats/requests/send/contact/" + bot_id, {
    target_id: targetedMessageId,
    contact_id: contact_id,
    id: chat.id,
  });
  if (res[0]) {
    return res[0];
  } else {
    showErrorToast(res, "Error al enviar el mensaje.");
    return null;
  }
};

export const sendFile = async (chat, files, audio, targetedMessageId, message) => {
  let data = {};
  if (audio) {
    data = {
      target_id: targetedMessageId,
      id: chat.id,
      files: [
        {
          filename: audio.filename + ".mp3",
          file: audio.file,
          type: audio.type,
          size: audio.size,
        },
      ],
    };
  } else if (files.length > 0) {
    data = {
      target_id: targetedMessageId,
      id: chat.id,
      files: files.map((f) => {
        return { filename: f.filename, file: f.file, type: f.type };
      }),
      caption: message || null
    };
  }

  const bot_id = localStorage.getItem("bot");
  const res = await postCall("/chats/requests/send/document/" + bot_id, data);
  if (res[0]) {
    if (res[0]?.status == 207 && res[0]?.message) {
      showInfoToast(res[0]?.message);
    }
    return res[0];
  } else {
    showErrorToast(res, "Error al enviar mensaje.");
    return null;
  }
};

export const startNewChat = async (newChat) => {
  const bot_id = localStorage.getItem("bot");
  const data = { ...newChat };
  const res = await postCall(
    "/chats/" + bot_id + "/" + newChat.contact_id + "/" + newChat.area,
    data
  );
  if (res[0]) {
    return res[0];
  } else {
    showErrorToast(res, "Error al iniciar chat.");
    return null;
  }
};

export const reactivateChatbot = async (chat) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/requests/reactivate/" + bot_id, {
    id: chat.id,
  });
  if (res[0]) {
    updateToast(idt, "success", "Chatbot reactivado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al reactivar chatbot.");
    return null;
  }
};

export const closeConversation = async (chat) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/requests/close/" + bot_id + "/" + chat.id);
  if (res[0]) {
    updateToast(idt, "success", "Chat cerrado correctamente.");
    return res[0].live_chat_data;
  } else {
    dispatchErrorMessage(idt, res, "Error al cerrar chat.");
    return null;
  }
};

export const toggleUnreadChat = async (chat) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/requests/unread/" + bot_id, {
    id: chat.id,
  });
  if (res[0]) {
    updateToast(idt, "success", "Estado de la conversación cambiado.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al cambiar el estado.");
    return null;
  }
};

export const toggleAnsweredChat = async (chat) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await putCall("/chats/answered/" + bot_id, {
    id: chat.id,
  });
  if (res[0]) {
    updateToast(idt, "success", "Estado de la conversación cambiado.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al cambiar el estado.");
    return null;
  }
};

// Quick Replies Services

export const getQuickReplies = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/chats/quick-replies/" + bot_id);
  if (res[0]) {
    return res[0].quick_replies;
  } else return null;
};

export const orderQuickReplies = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const res = await postCall(
    "/chats/quick-replies/order/" + bot_id,
    data
  );
  if (res[0]) {
    return res[0];
  } else return null;
};

export const addQuickReply = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall("/chats/quick-replies/" + bot_id, data);
  if (res[0]) {
    updateToast(idt, "success", "Respuesta rápida agregado.");
    return res[0].quick_reply;
  } else {
    dispatchErrorMessage(idt, res, "Error al agregar respuesta.");
    return null;
  }
};

export const editQuickReplies = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await putCall(
    "/chats/quick-replies/" + bot_id + "/" + data.id,
    data
  );
  if (res[0]) {
    updateToast(idt, "success", "Respuesta rápida editada con éxito.");
    return res[0].quick_reply;
  } else {
    dispatchErrorMessage(idt, res, "Error al editar respuesta rápida.");
    return null;
  }
};
export const deleteQuickReplies = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await deleteCall("/chats/quick-replies/" + bot_id + "/" + data.id);
  if (res[0]) {
    updateToast(idt, "success", "Respuesta rápida borrada con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al borrar respuesta rápida.");
    return null;
  }
};

// Labels Services

export const getLabels = async () => {
  const bot_id = localStorage.getItem("bot");

  const res = await getCall("/chats/labels/" + bot_id);
  if (res[0]) {
    return res[0].labels;
  } else return null;
};

export const getLabelsByChat = async (chat_id) => {
  const bot_id = localStorage.getItem("bot");

  const res = await getCall("/chats/labels/" + bot_id + "/" + chat_id);
  if (res[0]) {
    return res[0].labels;
  } else return null;
};

export const saveLabels = async (data, type) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  let res;
  if (type === "new") {
    res = await postCall("/chats/labels/" + bot_id, data);
  } else {
    res = await putCall("/chats/labels/" + bot_id, data);
  }
  if (res[0]) {
    updateToast(idt, "success", "Etiqueta guardada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al guardar etiqueta.");
    return null;
  }
};
export const deleteLabels = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await deleteCall("/chats/labels/" + bot_id + "/" + data.id);
  if (res[0]) {
    updateToast(idt, "success", "Etiqueta borrada con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al borrar etiqueta.");
    return null;
  }
};

export const cancelLabelAction = async (chatId, labelId) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await putCall(
    "/chats/labels/action/toggle/" + bot_id + "/" + chatId + "/" + labelId
  );
  if (res[0]) {
    updateToast(idt, "success", "Ejecución cancelada exitosamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al cancelar ejecución.");
    return null;
  }
};

export const turnAbleLabel = async (chat, label, bool) => {
  const bot_id = localStorage.getItem("bot");
  // const idt = loadingToast();
  let data = {
    id: chat.id,
    live_chat: chat.type,
    date: chat.date,
    added: bool,
    label_id: label,
  };
  const res = await putCall("/chats/labels/chat/" + bot_id, data);
  if (res[0]) {
    // updateToast(idt, "success", "Etiqueta guardada correctamente");
    return res[0];
  } else {
    // dispatchErrorMessage(idt, res, "Error al guardar etiqueta");
    return null;
  }
};
export const changeName = async (chat, name) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  let data = {
    id: chat.id,
    username: name,
  };
  const res = await putCall("/chats/username/" + bot_id, data);
  if (res[0]) {
    updateToast(idt, "success", "Nombre cambiado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al cambiar el nombre.");
    return null;
  }
};

export const getChatFile = async (mediaId, channel, messageId) => {
  const cachedData = await getFromCache(mediaId);
  if (cachedData) {
    return cachedData;
  }
  const bot_id = localStorage.getItem("bot");
  const res = await postCall("/chats/requests/get/document/" + bot_id, {
    media_id: mediaId,
    channel: channel,
    message_id: messageId,
  });
  if (res[0]) {
    await saveToCache(mediaId, res[0]);
    return res[0];
  } else {
    await saveToCache(mediaId, res[1]?.data);
    return null;
  }
};

export const getAudioTranscription = async (mediaId) => {
  const idt = loadingToast();
  const bot_id = localStorage.getItem("bot");
  const res = await getCall(
    "/chats/requests/audio/translate/" + bot_id + "/" + mediaId
  );
  if (res[0]) {
    updateToast(idt, "success", "Transcripción obtenida correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al intentar transcribir el audio.");
    return null;
  }
};

export const generateQuickBudget = async (quickBudgetData, sender_id) => {
  const idt = loadingToast();
  const bot_id = localStorage.getItem("bot");
  const [response] = await postFileCall(
    "/quickbudget/" + bot_id + "/" + sender_id,
    quickBudgetData
  );

  if (response) {
    const blob = new Blob([response], { type: "application/pdf" });
    updateToast(idt, "success", "Presupuesto enviado correctamente.");

    return blob;
  } else {
    dispatchErrorMessage(idt, response, "Error al enviar presupuesto.");

    return null;
  }
};
export const createAndSendQuickBudget = async (quickBudgetData, sender_id) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await postCall(
    "/quickbudget/send/" + bot_id + "/" + sender_id,
    quickBudgetData
  );
  if (res[0]) {
    updateToast(idt, "success", "Presupuesto generado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al enviar presupuesto.");
    return null;
  }
};
export const getUserAreas = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/chats/user/areas/" + bot_id);
  if (res[0]) {
    return res[0].areas;
  } else {
    return null;
  }
};
export const getUserContact = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/contacts/me/" + bot_id);
  if (res[0]) {
    return res[0].contact;
  } else {
    return null;
  }
};

export const exportChatToAPI = async (chatId, summary = null) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();

  const res = await postCall("/chats/lead/" + bot_id + "/" + chatId, {
    summary: summary || "",
  });
  if (res[0]?.lead_data) {
    updateToast(idt, "success", "Chat exportado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al exportar chat.");
    return null;
  }
};

export const downloadChat = async (chatId) => {
  const idt = loadingToast();
  const bot_id = localStorage.getItem("bot");

  const [response, error] = await getFileCall("/chats/download/" + bot_id + "/" + chatId);

  if (response) {
    const blob = new Blob([response], { type: "application/zip" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `chat_${chatId}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    updateToast(idt, "success", "Chat descargado correctamente.");
    return blob;
  } else {
    dispatchErrorMessage(idt, error, "Error al descargar chat.");
    return null;
  }
};

export const getLabelActions = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/chats/labels/actions/" + bot_id);
  if (res[0]) {
    return res[0].label_actions;
  } else {
    return null;
  }
};

export const getScoreChat = async (chatId) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await getCall("/chats/scores/bot-performance/" + bot_id + "/" + chatId);
  if (res[0]) {
    updateToast(idt, "success", "Chat evaluado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al evaluar chat.");
    return null;
  }
};

export const saveScoreChat = async (chatId, data) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();

  const res = await putCall("/chats/scores/bot-performance/" + bot_id + "/" + chatId, {
    score_data: data
  });
  if (res[0]) {
    updateToast(idt, "success", "Evaluación guardada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(idt, res, "Error al guardar evaluación del chat.");
    return null;
  }
};

export const addLeadQuality = async (chat, value) => {
  const bot_id = localStorage.getItem("bot");
  const idt = loadingToast();
  const res = await putCall("/chats/scores/lead-quality/" + bot_id + "/" + chat.id, {
    value: value,
  });
  if (res[0]) {
    updateToast(idt, "success", "Puntuación guardada correctamente.");
    return res[0].score_value;
  } else {
    dispatchErrorMessage(idt, res, "Error al agregar puntuación.");
    return null;
  }
};

export const getGeneralChatSettings = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/chats/general/settings/" + bot_id);
  if (res[0]) {
    return res[0].settings;
  } else return null;
};